module.exports = __webpack_public_path__ + "static/media/40-7.258d252f.mp3";